import {useNavigate} from "react-router-dom";
import {Button, YStack} from "@chayka/ui";
import {env} from "@/lib/env";
import {SignUpHeader} from "./Header";

export const SignUpPage = () => {
  const navigate = useNavigate();

  const openRegistration = () => {
    window.open(env.VITE_WP_REGISTRATION_URL, "_blank", "noopener,noreferrer");
  };

  return (
    <YStack className="relative justify-start items-center gap-5 w-full h-full">
      <SignUpHeader />
      <YStack className="relative flex-1 justify-between items-stretch gap-10 w-full h-full pb-12">
        <YStack className="gap-4 text-center">
          <h2 className="font-bold text-lg">Подтвердите номер телефона</h2>
          <p className="text-secondary-text">
            Регистрация откроется на сайте Chayka Studia в новой вкладке. Заполните форму и
            подтвердите номер с помощью автоматического звонка.
          </p>
          <p className="text-sm text-secondary-text">
            После завершения регистрации вернитесь в приложение и войдите по номеру телефона и
            паролю.
          </p>
        </YStack>

        <YStack className="gap-3">
          <Button onClick={openRegistration}>Продолжить регистрацию</Button>
          <Button variant="secondary" onClick={() => navigate("/auth/sign-in")}>
            Я зарегистрировался — войти
          </Button>
        </YStack>
      </YStack>
    </YStack>
  );
};
